import { apiClient, Auth } from '@/shared/api'

import { TGuestContractDetail } from '../model/schema'

export const getGuestContract = async (contractId: number) => {
  const response = await apiClient.get<TGuestContractDetail>({
    endpoint: `/guest/contracts/${contractId}`,
    auth: Auth.REQUIRED,
    // queryParams: {
    //   case: GUEST_CONTRACT_CASE.PAY_READY,
    // },
    // option: {
    //   useMock: true,
    // },
  })

  return response
}
